module.exports = __webpack_public_path__ + "static/media/payfast_logo_vector_small.77444a2f.png";